
export function phonenumbervalidator(node:HTMLInputElement, binding: any)
{
    return {
        update(value: string) {
            var targetnode = node;
            if(value && !value.match(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/) && !value.match(/^\d{10}$/))
            {
                targetnode.classList.add("field-validation-error")
            }
            else
            {
                targetnode.classList.remove("field-validation-error");
            }
        }
    }
}

export function zipcodevalidator(node:HTMLInputElement, binding: any)
{
    return {
        update(value: string) {
            if(value && !value.match(/^\d{5}(-\d{4})?$/))
            {
                node.classList.add("field-validation-error")
            }
            else
            {
                node.classList.remove("field-validation-error");
            }
        }
    }
}


export function ssnvalidator(node:HTMLInputElement, binding: any)
{
    return {
        update(value: string) {
            if(value && value.trim()!='' && !value.match(/^\d{3}-?\d{2}-?\d{4}$/) && !value.match(/^\d{9}$/))
            {
                node.classList.add("field-validation-error")
            }
            else
            {
                node.classList.remove("field-validation-error");
            }
        }
    }
}